import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-producein",
  "use": "icon-producein-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-producein\"><path d=\"M742.4 789.333333H938.666667v42.666667h-196.266667l38.4 38.4-29.866667 29.866667-89.6-89.6 89.6-89.6 29.866667 29.866666-38.4 38.4zM896 640h-42.666667v-89.6l-320-320L213.333333 550.4V810.666667h341.333334v42.666666H170.666667v-277.333333H128L533.333333 170.666667l405.333334 405.333333h-42.666667V640z\" fill=\"#ffffff\" p-id=\"8481\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol